import React, { useContext, useEffect, useState } from 'react'
import { FormField } from '../../../../Components/FormField'
import UploadSingleImage from '../../../../Components/UploadSingleImage'
import { ErrorMessage, Formik } from 'formik'
import TextInput from '../../../../Components/TextInput'
import GradientButton from '../../../../Components/Button/GradientButton'
import LoaderContext from '../../../../Components/loader'
import { BasicSettings } from '../../../../App/api/setting'
import { toast } from 'react-toastify'
import Lable from '../../../../Components/Lable'
import Phone from '../../../../Components/Phone'
import { IoIosInformationCircleOutline } from 'react-icons/io'
import Tooltip from '../../../../Components/Tooltip/Tooltip'



function SiteSettings() {


  const { handleLoading } = useContext(LoaderContext)
  const [editSiteData, setEditSiteData] = useState(null)

  const LabelNTooltip = {
    logo: { label: "Logo", tooltip: "Choose Logo" },
    titleIcon: { label: "Title Icon", tooltip: "Choose Title Icon" },
    userLogo: { label: "Customer Logo", tooltip: "Choose Customer Logo" },
    storeLogo: { label: "Store  Logo", tooltip: "Choose Store  Logo" },
    deliverymanLogo: { label: "Delivery Man  Logo", tooltip: "Delivery Man  Logo" },
    mailBackgroundLogo: { label: "Mail Background Logo", tooltip: "Mail Background  Logo" },
  }

  const handleSubmit = async (values,) => {
    try {
      handleLoading(true)
      const res = editSiteData?._id ? await BasicSettings.updateSiteSettings(values, editSiteData?._id) : await BasicSettings.createSiteSettings(values)
      // console.log("res",res);
      toast.success(`Site setting successfully ${editSiteData?._id ? 'updated' : 'created'}!`)

      handleLoading(false)
    } catch (error) {
      handleLoading(false)

    }
  }

  const getSiteSettings = async () => {
    try {
      handleLoading(true)
      const res = await BasicSettings.getSiteSettings()
      // console.log('res',res.data.data);
      setEditSiteData(res?.data?.data[0])
      handleLoading(false)
    } catch (error) {
      handleLoading(false)
    }
  }

  useEffect(() => {
    getSiteSettings()
  }, [])

  return (
    <div className={`bg-[--bg-color] shadow-[--shadow 0px 2px 8px 0px] p-5 rounded-md`}>
      <p className='text-[1.5rem] my-6'>Site Settting</p>
      <Formik
        enableReinitialize={true}
        initialValues={{
          appName: editSiteData?.appName || null,
          contactPhone: editSiteData?.contactPhone || null,
          contactEmail: editSiteData?.contactEmail || null,
          logo: editSiteData?.logo || null,
          titleIcon: editSiteData?.titleIcon || null,
          userLogo: editSiteData?.userLogo || null,
          storeLogo: editSiteData?.storeLogo || null,
          deliverymanLogo: editSiteData?.deliverymanLogo || null,
          mailBackgroundLogo: editSiteData?.mailBackgroundLogo || null,
        }}
        //   validationSchema={productVariantSchema}      

        onSubmit={(values) => {
          // console.log('value',values);
          handleSubmit(values)
        }}
      >
        {({ handleChange, setFieldValue, values, handleSubmit }) => (
          <>

            <div className="gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
              <FormField label={"Application Name"} tooltip={"Name Of Application"}>
                <TextInput
                  name="appName"
                  type="text"
                  placeholder="Enter Application Name"
                  onChange={handleChange}
                  value={values.appName}
                  required={true}
                />
              </FormField>
              <FormField label={"Contact Email"} tooltip={"Enter Contact Email"}>
                <TextInput
                  name="contactEmail"
                  type="text"
                  placeholder="Enter Email"
                  onChange={handleChange}
                  value={values.contactEmail}
                  required={true}
                  pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$"
                />
                <ErrorMessage
                  name="contactEmail"
                  component="div"
                  className="error"
                />
              </FormField>
              {/* <Lable lable="Phone" /> */}
              <div>
                <Phone
                  value={values.contactPhone}
                  name="contactPhone"
                  handleChange={(data) => {
                    // console.log('Data',data?.phone);                  
                    setFieldValue(`contactPhone`, data?.phone)
                  }}
                />
                <ErrorMessage
                  name="contactPhone"
                  component="div"
                  className="error"
                />
              </div>
            </div>
            <div className='flex flex-wrap justify-center items-center gap-3'>
              {
                Object.keys(LabelNTooltip).map((key, i) => (
                  <div>
                    <UploadSingleImage
                      label={LabelNTooltip[key]?.label}
                      tooltip={LabelNTooltip[key]?.tooltip}
                      name={key}
                      value={values[key]}
                      handleFileUpload={(fileValue) => {
                        // console.log('fileValue',fileValue);    
                        setFieldValue(`${key}`, fileValue)
                      }}
                    />
                    <ErrorMessage
                      name={key}
                      component="div"
                      className="blink-shadow error px-4 py-1"
                    />
                  </div>
                ))
              }
            </div>

            <div className='flex items-center justify-center'>
              <GradientButton label="Submit" onClick={handleSubmit} />
            </div>
          </>
        )}



      </Formik>
    </div>
  )
}

export default SiteSettings